__turbopack_context__.v({
  "bentoCard": "_6l-qGW_bentoCard",
  "bentoGrid": "_6l-qGW_bentoGrid",
  "root": "_6l-qGW_root",
  "span-2": "_6l-qGW_span-2",
});
